import React from 'react';

function Navigation() {
  return (
    <nav className="bg-white/5 backdrop-blur-md border-b border-white/20">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🪔</span>
          <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            ASTROGEM API
          </span>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
